export const parseBooleanLike = (value) => {
    if (typeof value === "boolean") return value;

    if (typeof value === "number") {
        if (value === 1) return true;
        if (value === 0) return false;
    }

    if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (!normalized) return false;

        if (["true", "t", "yes", "y", "1"].includes(normalized)) return true;
        if (["false", "f", "no", "n", "0"].includes(normalized)) return false;
    }

    return null;
};

export const isTrueLike = (value) => parseBooleanLike(value) === true;
